import React from "react";

export function RowSkeleton() {
  return (
    <div className="px-4 md:px-12 my-8">
      <div className="h-6 w-48 skeleton rounded mb-4" />
      <div className="flex gap-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="shrink-0 w-[150px] sm:w-[170px] md:w-[190px] aspect-[2/3] rounded-lg skeleton" />
        ))}
      </div>
    </div>
  );
}

export function HeroSkeleton() {
  return <div className="h-[78vh] md:h-[88vh] w-full skeleton" />;
}
